// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_ADD_REVIEW = "Pridaj hodnotenie";
export const STROLLER_MORE_REVIEWS = "\u010eal\u0161ie hodnotenia";
export const STROLLER_NO_REVIEWS = "Zatia\u013e nikto nehodnotil tento ko\u010d\u00edk";
export const STROLLER_REVIEWS_FROM_MOTHERS = "Hodnotenia od mami\u010diek";
